import { chaveFamiliaProduto, gerarNomeUnificadoInteligente, nomeProdutoLimpo } from '../components/corte/familiasProdutos';
import { descricaoPecaSemCor, nomeProdutoSemCor } from './resolverProdutoPontuacao';

export function materialChaveAdiantamento(material: unknown): string {
  return String(material || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/\s+/g, ' ')
    .trim();
}

/** Mesmo produto com medidas diferentes (ESTONE 1.4 e 1.8) → mesma chave. */
export function chaveGrupoVarianteAdiantamento(nomeProduto: string): string {
  const limpo = nomeProdutoLimpo(nomeProdutoSemCor(nomeProduto));
  if (!limpo) return '';
  const fam = chaveFamiliaProduto(nomeProduto);
  if (fam && fam !== limpo) return fam;
  const semMedida = limpo.replace(/\s+\d+(?:[.,]\d+)?$/, '').trim();
  return semMedida || limpo;
}

export function rotuloVariantesAdiantamento(nomes: string[]): string {
  const unicos = [
    ...new Set(nomes.map((n) => nomeProdutoSemCor(n).toUpperCase()).filter(Boolean)),
  ];
  if (unicos.length === 0) return '';
  if (unicos.length === 1) return unicos[0];
  const intel = gerarNomeUnificadoInteligente(unicos).replace(/ \+ /g, ' e ');
  if (intel) return intel.toUpperCase();
  return unicos.join(' e ');
}

export function chaveLinhaUnificadaAdiantamento(
  grupo: string,
  descricao: string,
  material: string
): string {
  return `${grupo}|${descricaoPecaSemCor(descricao).toUpperCase()}|${materialChaveAdiantamento(material)}`;
}
